import { render } from "./AdditionalKitaComponent.vue?vue&type=template&id=88e2ce98"
import script from "./AdditionalKitaComponent.vue?vue&type=script&lang=js"
export * from "./AdditionalKitaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__